/* ⚡ Fun facts on animal collection pages. See sections/dw-fun-facts.liquid */
(() => {
  const facts = window.DW_FACTS || {};
  const modal = document.querySelector('[data-fact-modal]');
  if (!modal) return;
  document.body.appendChild(modal);
  const animalEl = modal.querySelector('[data-fact-animal]');
  const textEl = modal.querySelector('[data-fact-text]');
  let lastBtn = null;

  const handleOf = (a) => {
    const m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  };

  function decorate() {
    document.querySelectorAll('.card__inner').forEach((inner) => {
      if (inner.querySelector('.dw-fact-btn')) return;
      const link = inner.querySelector('a[href*="/products/"]') || inner.closest('.card-wrapper')?.querySelector('a[href*="/products/"]');
      const handle = link && handleOf(link);
      if (!handle || !facts[handle]) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dw-fact-btn';
      btn.dataset.handle = handle;
      btn.setAttribute('aria-label', `Fun fact about the ${facts[handle][0]}`);
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M13.5 2 4.8 13.4h6.1L9.9 22l9.3-12.1h-6.3L13.5 2z"/></svg>';
      inner.appendChild(btn);
    });
  }

  function open(handle, btn) {
    const [animal, fact] = facts[handle];
    animalEl.textContent = animal;
    textEl.textContent = fact;
    lastBtn = btn;
    modal.hidden = false;
    requestAnimationFrame(() => modal.classList.add('is-open'));
    document.body.classList.add('dw-fact-open');
    modal.querySelector('[data-fact-close]').focus();
  }

  function close() {
    modal.classList.remove('is-open');
    document.body.classList.remove('dw-fact-open');
    setTimeout(() => (modal.hidden = true), 200);
    if (lastBtn) lastBtn.focus();
  }

  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('.dw-fact-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      open(btn.dataset.handle, btn);
    },
    true
  );
  modal.addEventListener('click', (e) => {
    if (e.target === modal || e.target.closest('[data-fact-close]')) close();
  });
  document.addEventListener('keydown', (e) => e.key === 'Escape' && !modal.hidden && close());

  decorate();
  // Cards added later (filters, sorting, load more)
  new MutationObserver(decorate).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
})();
